<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_PATRIMONY_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.patrimony;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(patrimony) {
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_PATRIMONY_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(patrimony, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updatePatrimony.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_PATRIMONY_QUERY = gql `
  query ($id: ID!) { 
    accountContext {
      patrimony(id: $id) {
        id
        patrimonyCategoryId
        patrimonyCategory {
          id
          name
          kind
        }
        brandId
        description
        enabled
        chassi
        hourlyPrice
        model
        plate
        year
        price
        serialNumber
        motorNumber
        potency
        observation
        insurancePolicyNumber
        insuranceExpirationDate
        renavan
        axesNumber
        grossWeight
        loadCapacity
        bodywork
        tare
        wheeledType
        bodyType
        colorId
        plateStateId
        workingMetricType
        workingMetricTypeValue
        validations
      }
    }
    globalContext {
      allPatrimonyCategories {
        id
        name
        kind
      }
      allStates {
        id
        name
        shortName
      }
      allColors {
        id
        name
        hexaCode
      }
      allWheeledTypes
      allBodyTypes
      allPatrimonyWorkingMetricTypes
    }
    accountGlobalSharedContext {
      allPatrimonyBrands {
        id
        name
      }
    }
  }
`;

const UPDATE_PATRIMONY_MUTATION = gql `
  mutation($input: PatrimonyUpdateInputObject!) {
    updatePatrimony(input: $input) {
      patrimony {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
